export default function getTopOffset(element, stopElement = document.body) {
	if (!element) {
		return 0;
	}

	let recursiveOffset = 0;
	if (element.offsetParent && element.offsetParent !== stopElement) {
		recursiveOffset = getTopOffset(element.offsetParent, stopElement);
	}

	return recursiveOffset + element.offsetTop;
}

export function getLeftOffset(element, stopElement = document.body) {
	if (!element) {
		return 0;
	}

	let recursiveOffset = 0;
	if (element.offsetParent && element.offsetParent !== stopElement) {
		recursiveOffset = getLeftOffset(element.offsetParent, stopElement);
	}

	return recursiveOffset + element.offsetLeft;
}



/** WEBPACK FOOTER **
 ** ./frontend/utils/getOffsetTop.js
 **/